import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

type VideoFullscreenContextValue = {
  isVideoFullscreen: boolean;
  setVideoFullscreen: (value: boolean) => void;
};

const VideoFullscreenContext = createContext<VideoFullscreenContextValue>({
  isVideoFullscreen: false,
  setVideoFullscreen: () => {},
});

export const VideoFullscreenProvider: React.FC = ({ children }) => {
  const [isVideoFullscreen, setIsVideoFullscreen] = useState(false);

  const setVideoFullscreen = useCallback((value: boolean) => {
    setIsVideoFullscreen(value);
    document.body.classList.toggle('video-fullscreen', value);
  }, []);

  useEffect(() => {
    const onFullscreenChange = () => {
      const isFullscreen = Boolean(document.fullscreenElement);
      setIsVideoFullscreen(isFullscreen);
      document.body.classList.toggle('video-fullscreen', isFullscreen);
    };

    document.addEventListener('fullscreenchange', onFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, []);

  return (
    <VideoFullscreenContext.Provider value={{ isVideoFullscreen, setVideoFullscreen }}>
      {children}
    </VideoFullscreenContext.Provider>
  );
};

export const useVideoFullscreen = () => useContext(VideoFullscreenContext);
